import { required } from '@rxweb/reactive-form-validators';

export class ReelCategoryModel {
	@required()
	title: string;

	@required()
	type: string;

	@required()
	category_id: string;

}
